import React from 'react';
import { FEATURES } from '../constants/featureFlags';
import VideoSection from '../components/VideoSection';
import useScrollToTop from '../hooks/useScrollToTop';

const Home = () => {
  useScrollToTop();

  return (
    <div className="home">
      <section className="hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <p className="hero-subtitle">Bespoke Scottish touring in a luxury 7-seater Mercedes V-Class</p>
          <a href="/about" className="learn-more-btn">Learn More</a>
        </div>
      </section>

      {FEATURES.homeImageGallery && <section className="image-gallery">
        <div className="gallery-grid">
          <div className="gallery-item">
            <img loading="lazy" src="https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Scottish Highlands" />
          </div>
          <div className="gallery-item">
            <img loading="lazy" src="https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Edinburgh Castle" />
          </div>
          <div className="gallery-item">
            <img loading="lazy" src="https://images.unsplash.com/photo-1539650116574-75c0c6d73f6e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Isle of Skye" />
          </div>
          <div className="gallery-item">
            <img loading="lazy" src="https://images.unsplash.com/photo-1580055733133-2f2da6295ad4?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Loch Ness" />
          </div>
        </div>
      </section>}

      {FEATURES.homeTestimonials && <section className="testimonials">
        <div className="container">
          <h2>What Our Customers Say</h2>
          <div className="testimonials-grid">
            <div className="testimonial">
              <div className="testimonial-content">
                <p>"Absolutely fantastic experience! The wine country tour was perfectly organized and our guide was incredibly knowledgeable. The bus was luxurious and comfortable throughout the entire journey."</p>
              </div>
              <div className="testimonial-author">
                <strong>Sarah Johnson</strong>
                <span>Wine Country Adventure</span>
                <div className="rating">⭐⭐⭐⭐⭐</div>
              </div>
            </div>
            <div className="testimonial">
              <div className="testimonial-content">
                <p>"Travel Mhor exceeded all expectations. The city highlights tour was comprehensive and we learned so much about the local history. Highly recommend for families!"</p>
              </div>
              <div className="testimonial-author">
                <strong>Michael Chen</strong>
                <span>City Highlights Tour</span>
                <div className="rating">⭐⭐⭐⭐⭐</div>
              </div>
            </div>
            <div className="testimonial">
              <div className="testimonial-content">
                <p>"Professional service from start to finish. The historical heritage tour was fascinating and the driver was punctual and courteous. Will definitely book again!"</p>
              </div>
              <div className="testimonial-author">
                <strong>Emma Williams</strong>
                <span>Historical Heritage Tour</span>
                <div className="rating">⭐⭐⭐⭐⭐</div>
              </div>
            </div>
          </div>
        </div>
      </section>}

      {FEATURES.homeAboutPreview && <section className="about-preview">
        <div className="container">
          <div className="about-preview-content">
            <div className="about-preview-text">
              <h2>Discover Your Next Adventure</h2>
              <p>
                At Travel Mhor, we believe that every journey should be extraordinary.
                We specialize in providing luxury transportation and expertly guided tours that
                showcase the best destinations in comfort and style.
              </p>
              <p>
                Our commitment to excellence means you can relax and enjoy the scenery while 
                our professional drivers and knowledgeable guides take care of every detail. 
                Whether you're exploring historic landmarks, scenic wine country, or vibrant 
                city attractions, we ensure your journey is as memorable as your destination.
              </p>
              <a href="/about" className="btn btn-primary">Learn More About Us</a>
            </div>
            <div className="about-preview-image">
              <img
                loading="lazy"
                src="https://images.unsplash.com/photo-1570125909232-eb263c188f7e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
                alt="Modern tour bus on scenic highway"
              />
            </div>
          </div>
        </div>
      </section>}

      {process.env.REACT_APP_ENABLE_HOME_VIDEO !== 'false' && <VideoSection
        videoSrc="/videos/home-video.mp4"
        altText="Bespoke Scottish tours in luxury Mercedes V-Class"
      />}
    </div>
  );
};

export default Home;